import { createReducer, on } from '@ngrx/store';
import {
  handleRequest,
  handleSuccess,
  handleFailure,
  handleClear,
} from '@shared/ngrx-factory/factory.reducer';
import {
  omcActiveOpenDemandCyclesActions,
  omcContractsListActions,
  omcCreateStockReportActions,
  omcCurrentWindowDemandDraftActions,
  omcSubmitStockReportActions,
  omcUpdateStockReportActions,
  omcDemandByUuidActions,
  omcDemandCycleByUuidActions,
  omcDemandCyclesActions,
  omcDemandSubmissionsActions,
  omcStockReportDetailActions,
  omcTerminalAgreementByUuidActions,
  omcCreateTerminalAgreementActions,
  omcSubmitTerminalAgreementActions,
  omcUpdateTerminalAgreementActions,
  omcDraftDemandActions,
  omcListActions,
  omcStockReportsActions,
  omcSubmitUsageReportActions,
  omcUpdateUsageReportActions,
  omcTerminalSameTinActions,
  omcTerminalAgreementsActions,
  omcDemandProjectionActions,
  omcCertificatePreviewActions,
  omcTransitConsigneesActions,
  omcTransitStocksActions,
  omcDeleteDemandDraftActions,
  omcOverduePendingBillsSummaryActions,
  omcRequiredGuaranteeSummaryActions,
  omcProductMarketShareSummaryActions,
  omcSubmitDemandActions,
  OmcSignContractActions,
  loggedInOmcLastMonthsProjectsActions,
  loadBpsCalendarActions,
  deleteOmcDemandCargoProductActions,
  deleteOmcDemandProductUsageActions,
} from './omc-management.actions';
import { OmcManagementState, initialOmcManagementState } from './omc-management.state';

export const omcManagementReducer = createReducer(
  initialOmcManagementState,
  // OMC List
  on(omcListActions.request, (state) => handleRequest(state, 'omcList')),
  on(omcListActions.success, (state, { response }) => handleSuccess(state, 'omcList', response)),
  on(omcListActions.failure, (state, { error }) => handleFailure(state, 'omcList', error)),
  on(omcListActions.clearState, (state) => handleClear(state, 'omcList')),

  // OMC Contracts List
  on(omcContractsListActions.request, (state) => handleRequest(state, 'omcContractsList')),
  on(omcContractsListActions.success, (state, { response }) =>
    handleSuccess(state, 'omcContractsList', response),
  ),
  on(omcContractsListActions.failure, (state, { error }) =>
    handleFailure(state, 'omcContractsList', error),
  ),
  on(omcContractsListActions.clearState, (state) => handleClear(state, 'omcContractsList')),

  // OMC Demand Submissions
  on(omcDemandSubmissionsActions.request, (state) => handleRequest(state, 'omcDemandSubmissions')),
  on(omcDemandSubmissionsActions.success, (state, { response }) =>
    handleSuccess(state, 'omcDemandSubmissions', response),
  ),
  on(omcDemandSubmissionsActions.failure, (state, { error }) =>
    handleFailure(state, 'omcDemandSubmissions', error),
  ),
  on(omcDemandSubmissionsActions.clearState, (state) =>
    handleClear(state, 'omcDemandSubmissions'),
  ),

  // OMC Demand Windows
  on(omcDemandCyclesActions.request, (state) => handleRequest(state, 'omcDemandCycles')),
  on(omcDemandCyclesActions.success, (state, { response }) =>
    handleSuccess(state, 'omcDemandCycles', response),
  ),
  on(omcDemandCyclesActions.failure, (state, { error }) =>
    handleFailure(state, 'omcDemandCycles', error),
  ),
  on(omcDemandCyclesActions.clearState, (state) => handleClear(state, 'omcDemandCycles')),

  // OMC Active Open Demand Windows
  on(omcActiveOpenDemandCyclesActions.request, (state) =>
    handleRequest(state, 'omcActiveOpenDemandCycles'),
  ),
  on(omcActiveOpenDemandCyclesActions.success, (state, { response }) =>
    handleSuccess(state, 'omcActiveOpenDemandCycles', response),
  ),
  on(omcActiveOpenDemandCyclesActions.failure, (state, { error }) =>
    handleFailure(state, 'omcActiveOpenDemandCycles', error),
  ),
  on(omcActiveOpenDemandCyclesActions.clearState, (state) =>
    handleClear(state, 'omcActiveOpenDemandCycles'),
  ),

  // OMC Demand Window Detail
  on(omcDemandCycleByUuidActions.request, (state) =>
    handleRequest(state, 'omcDemandCycleByUuid'),
  ),
  on(omcDemandCycleByUuidActions.success, (state, { response }) =>
    handleSuccess(state, 'omcDemandCycleByUuid', response),
  ),
  on(omcDemandCycleByUuidActions.failure, (state, { error }) =>
    handleFailure(state, 'omcDemandCycleByUuid', error),
  ),
  on(omcDemandCycleByUuidActions.clearState, (state) =>
    handleClear(state, 'omcDemandCycleByUuid'),
  ),

  // OMC Demand Detail
  on(omcDemandByUuidActions.request, (state) => handleRequest(state, 'omcDemandByUuid')),
  on(omcDemandByUuidActions.success, (state, { response }) =>
    handleSuccess(state, 'omcDemandByUuid', response),
  ),
  on(omcDemandByUuidActions.failure, (state, { error }) =>
    handleFailure(state, 'omcDemandByUuid', error),
  ),
  on(omcDemandByUuidActions.clearState, (state) => handleClear(state, 'omcDemandByUuid')),

  // Current Window Demand Draft
  on(omcCurrentWindowDemandDraftActions.request, (state) =>
    handleRequest(state, 'omcCurrentWindowDemandDraft'),
  ),
  on(omcCurrentWindowDemandDraftActions.success, (state, { response }) =>
    handleSuccess(state, 'omcCurrentWindowDemandDraft', response),
  ),
  on(omcCurrentWindowDemandDraftActions.failure, (state, { error }) =>
    handleFailure(state, 'omcCurrentWindowDemandDraft', error),
  ),
  on(omcCurrentWindowDemandDraftActions.clearState, (state) =>
    handleClear(state, 'omcCurrentWindowDemandDraft'),
  ),

  // OMC Draft Demand
  on(omcDraftDemandActions.request, (state) => handleRequest(state, 'omcDraftDemand')),
  on(omcDraftDemandActions.success, (state, { response }) =>
    handleSuccess(state, 'omcDraftDemand', response),
  ),
  on(omcDraftDemandActions.failure, (state, { error }) =>
    handleFailure(state, 'omcDraftDemand', error),
  ),
  on(omcDraftDemandActions.clearState, (state) => handleClear(state, 'omcDraftDemand')),

  // OMC Demand Projection
  on(omcDemandProjectionActions.request, (state) => handleRequest(state, 'omcDemandProjection')),
  on(omcDemandProjectionActions.success, (state, { response }) =>
    handleSuccess(state, 'omcDemandProjection', response),
  ),
  on(omcDemandProjectionActions.failure, (state, { error }) =>
    handleFailure(state, 'omcDemandProjection', error),
  ),
  on(omcDemandProjectionActions.clearState, (state) =>
    handleClear(state, 'omcDemandProjection'),
  ),

  // Transit Consignees
  on(omcTransitConsigneesActions.request, (state) => handleRequest(state, 'omcTransitConsignees')),
  on(omcTransitConsigneesActions.success, (state, { response }) =>
    handleSuccess(state, 'omcTransitConsignees', response),
  ),
  on(omcTransitConsigneesActions.failure, (state, { error }) =>
    handleFailure(state, 'omcTransitConsignees', error),
  ),
  on(omcTransitConsigneesActions.clearState, (state) =>
    handleClear(state, 'omcTransitConsignees'),
  ),

  // Transit Stocks
  on(omcTransitStocksActions.request, (state) => handleRequest(state, 'omcTransitStocks')),
  on(omcTransitStocksActions.success, (state, { response }) =>
    handleSuccess(state, 'omcTransitStocks', response),
  ),
  on(omcTransitStocksActions.failure, (state, { error }) =>
    handleFailure(state, 'omcTransitStocks', error),
  ),
  on(omcTransitStocksActions.clearState, (state) => handleClear(state, 'omcTransitStocks')),

  // OMC Submit Demand
  on(omcSubmitDemandActions.request, (state) => handleRequest(state, 'omcSubmitDemand')),
  on(omcSubmitDemandActions.success, (state, { response }) =>
    handleSuccess(state, 'omcSubmitDemand', response),
  ),
  on(omcSubmitDemandActions.failure, (state, { error }) =>
    handleFailure(state, 'omcSubmitDemand', error),
  ),
  on(omcSubmitDemandActions.clearState, (state) => handleClear(state, 'omcSubmitDemand')),

  // OMC Delete Demand Draft
  on(omcDeleteDemandDraftActions.request, (state) => handleRequest(state, 'omcDeleteDemandDraft')),
  on(omcDeleteDemandDraftActions.success, (state, { response }) =>
    handleSuccess(state, 'omcDeleteDemandDraft', response),
  ),
  on(omcDeleteDemandDraftActions.failure, (state, { error }) =>
    handleFailure(state, 'omcDeleteDemandDraft', error),
  ),
  on(omcDeleteDemandDraftActions.clearState, (state) =>
    handleClear(state, 'omcDeleteDemandDraft'),
  ),

  // Required Guarantee Summary
  on(omcRequiredGuaranteeSummaryActions.request, (state) =>
    handleRequest(state, 'omcRequiredGuaranteeSummary'),
  ),
  on(omcRequiredGuaranteeSummaryActions.success, (state, { response }) =>
    handleSuccess(state, 'omcRequiredGuaranteeSummary', response),
  ),
  on(omcRequiredGuaranteeSummaryActions.failure, (state, { error }) =>
    handleFailure(state, 'omcRequiredGuaranteeSummary', error),
  ),
  on(omcRequiredGuaranteeSummaryActions.clearState, (state) =>
    handleClear(state, 'omcRequiredGuaranteeSummary'),
  ),

  // Required OMC Product Market Share Summary
  on(omcProductMarketShareSummaryActions.request, (state) =>
    handleRequest(state, 'omcProductMarketShareSummary'),
  ),
  on(omcProductMarketShareSummaryActions.success, (state, { response }) =>
    handleSuccess(state, 'omcProductMarketShareSummary', response),
  ),
  on(omcProductMarketShareSummaryActions.failure, (state, { error }) =>
    handleFailure(state, 'omcProductMarketShareSummary', error),
  ),
  on(omcProductMarketShareSummaryActions.clearState, (state) =>
    handleClear(state, 'omcProductMarketShareSummary'),
  ),

  // Overdue Pending Bills Summary
  on(omcOverduePendingBillsSummaryActions.request, (state) =>
    handleRequest(state, 'omcOverduePendingBillsSummary'),
  ),
  on(omcOverduePendingBillsSummaryActions.success, (state, { response }) =>
    handleSuccess(state, 'omcOverduePendingBillsSummary', response),
  ),
  on(omcOverduePendingBillsSummaryActions.failure, (state, { error }) =>
    handleFailure(state, 'omcOverduePendingBillsSummary', error),
  ),
  on(omcOverduePendingBillsSummaryActions.clearState, (state) =>
    handleClear(state, 'omcOverduePendingBillsSummary'),
  ),

  // OMC Terminal Agreements
  on(omcTerminalAgreementsActions.request, (state) => handleRequest(state, 'omcTerminalAgreements')),
  on(omcTerminalAgreementsActions.success, (state, { response }) =>
    handleSuccess(state, 'omcTerminalAgreements', response),
  ),
  on(omcTerminalAgreementsActions.failure, (state, { error }) =>
    handleFailure(state, 'omcTerminalAgreements', error),
  ),
  on(omcTerminalAgreementsActions.clearState, (state) =>
    handleClear(state, 'omcTerminalAgreements'),
  ),

  // OMC Terminal Agreement Detail
  on(omcTerminalAgreementByUuidActions.request, (state) =>
    handleRequest(state, 'omcTerminalAgreementByUuid'),
  ),
  on(omcTerminalAgreementByUuidActions.success, (state, { response }) =>
    handleSuccess(state, 'omcTerminalAgreementByUuid', response),
  ),
  on(omcTerminalAgreementByUuidActions.failure, (state, { error }) =>
    handleFailure(state, 'omcTerminalAgreementByUuid', error),
  ),
  on(omcTerminalAgreementByUuidActions.clearState, (state) =>
    handleClear(state, 'omcTerminalAgreementByUuid'),
  ),

  // OMC Stock Reports
  on(omcStockReportsActions.request, (state) => handleRequest(state, 'omcStockReports')),
  on(omcStockReportsActions.success, (state, { response }) =>
    handleSuccess(state, 'omcStockReports', response),
  ),
  on(omcStockReportsActions.failure, (state, { error }) =>
    handleFailure(state, 'omcStockReports', error),
  ),
  on(omcStockReportsActions.clearState, (state) => handleClear(state, 'omcStockReports')),

  // OMC Stock Report Detail
  on(omcStockReportDetailActions.request, (state) => handleRequest(state, 'omcStockReportDetail')),
  on(omcStockReportDetailActions.success, (state, { response }) =>
    handleSuccess(state, 'omcStockReportDetail', response),
  ),
  on(omcStockReportDetailActions.failure, (state, { error }) =>
    handleFailure(state, 'omcStockReportDetail', error),
  ),
  on(omcStockReportDetailActions.clearState, (state) =>
    handleClear(state, 'omcStockReportDetail'),
  ),

  // Create OMC Stock Report
  on(omcCreateStockReportActions.request, (state) => handleRequest(state, 'omcCreateStockReport')),
  on(omcCreateStockReportActions.success, (state, { response }) =>
    handleSuccess(state, 'omcCreateStockReport', response),
  ),
  on(omcCreateStockReportActions.failure, (state, { error }) =>
    handleFailure(state, 'omcCreateStockReport', error),
  ),
  on(omcCreateStockReportActions.clearState, (state) =>
    handleClear(state, 'omcCreateStockReport'),
  ),

  // Update OMC Stock Report
  on(omcUpdateStockReportActions.request, (state) => handleRequest(state, 'omcUpdateStockReport')),
  on(omcUpdateStockReportActions.success, (state, { response }) =>
    handleSuccess(state, 'omcUpdateStockReport', response),
  ),
  on(omcUpdateStockReportActions.failure, (state, { error }) =>
    handleFailure(state, 'omcUpdateStockReport', error),
  ),
  on(omcUpdateStockReportActions.clearState, (state) =>
    handleClear(state, 'omcUpdateStockReport'),
  ),

  // Submit OMC Stock Report
  on(omcSubmitStockReportActions.request, (state) => handleRequest(state, 'omcSubmitStockReport')),
  on(omcSubmitStockReportActions.success, (state, { response }) =>
    handleSuccess(state, 'omcSubmitStockReport', response),
  ),
  on(omcSubmitStockReportActions.failure, (state, { error }) =>
    handleFailure(state, 'omcSubmitStockReport', error),
  ),
  on(omcSubmitStockReportActions.clearState, (state) =>
    handleClear(state, 'omcSubmitStockReport'),
  ),

  // Submit OMC Usage Report
  on(omcSubmitUsageReportActions.request, (state) => handleRequest(state, 'omcSubmitUsageReport')),
  on(omcSubmitUsageReportActions.success, (state, { response }) =>
    handleSuccess(state, 'omcSubmitUsageReport', response),
  ),
  on(omcSubmitUsageReportActions.failure, (state, { error }) =>
    handleFailure(state, 'omcSubmitUsageReport', error),
  ),
  on(omcSubmitUsageReportActions.clearState, (state) =>
    handleClear(state, 'omcSubmitUsageReport'),
  ),

  // Update OMC Usage Report
  on(omcUpdateUsageReportActions.request, (state) => handleRequest(state, 'omcUpdateUsageReport')),
  on(omcUpdateUsageReportActions.success, (state, { response }) =>
    handleSuccess(state, 'omcUpdateUsageReport', response),
  ),
  on(omcUpdateUsageReportActions.failure, (state, { error }) =>
    handleFailure(state, 'omcUpdateUsageReport', error),
  ),
  on(omcUpdateUsageReportActions.clearState, (state) =>
    handleClear(state, 'omcUpdateUsageReport'),
  ),

  // Create OMC Terminal Agreement
  on(omcCreateTerminalAgreementActions.request, (state) =>
    handleRequest(state, 'omcCreateTerminalAgreement'),
  ),
  on(omcCreateTerminalAgreementActions.success, (state, { response }) =>
    handleSuccess(state, 'omcCreateTerminalAgreement', response),
  ),
  on(omcCreateTerminalAgreementActions.failure, (state, { error }) =>
    handleFailure(state, 'omcCreateTerminalAgreement', error),
  ),
  on(omcCreateTerminalAgreementActions.clearState, (state) =>
    handleClear(state, 'omcCreateTerminalAgreement'),
  ),

  // Update OMC Terminal Agreement
  on(omcUpdateTerminalAgreementActions.request, (state) =>
    handleRequest(state, 'omcUpdateTerminalAgreement'),
  ),
  on(omcUpdateTerminalAgreementActions.success, (state, { response }) =>
    handleSuccess(state, 'omcUpdateTerminalAgreement', response),
  ),
  on(omcUpdateTerminalAgreementActions.failure, (state, { error }) =>
    handleFailure(state, 'omcUpdateTerminalAgreement', error),
  ),
  on(omcUpdateTerminalAgreementActions.clearState, (state) =>
    handleClear(state, 'omcUpdateTerminalAgreement'),
  ),

  // Submit OMC Terminal Agreement
  on(omcSubmitTerminalAgreementActions.request, (state) =>
    handleRequest(state, 'omcSubmitTerminalAgreement'),
  ),
  on(omcSubmitTerminalAgreementActions.success, (state, { response }) =>
    handleSuccess(state, 'omcSubmitTerminalAgreement', response),
  ),
  on(omcSubmitTerminalAgreementActions.failure, (state, { error }) =>
    handleFailure(state, 'omcSubmitTerminalAgreement', error),
  ),
  on(omcSubmitTerminalAgreementActions.clearState, (state) =>
    handleClear(state, 'omcSubmitTerminalAgreement'),
  ),

  // OMC Terminal Same TIN
  on(omcTerminalSameTinActions.request, (state) => handleRequest(state, 'omcTerminalSameTin')),
  on(omcTerminalSameTinActions.success, (state, { response }) =>
    handleSuccess(state, 'omcTerminalSameTin', response),
  ),
  on(omcTerminalSameTinActions.failure, (state, { error }) =>
    handleFailure(state, 'omcTerminalSameTin', error),
  ),
  on(omcTerminalSameTinActions.clearState, (state) =>
    handleClear(state, 'omcTerminalSameTin'),
  ),

  // OMC Sign Contract
  on(OmcSignContractActions.request, (state) => handleRequest(state, 'omcSignContract')),
  on(OmcSignContractActions.success, (state, { response }) =>
    handleSuccess(state, 'omcSignContract', response),
  ),
  on(OmcSignContractActions.failure, (state, { error }) =>
    handleFailure(state, 'omcSignContract', error),
  ),
  on(OmcSignContractActions.clearState, (state) =>
    handleClear(state, 'omcSignContract'),
  ),

  // OMC Certificate Preview
  on(omcCertificatePreviewActions.request, (state) =>
    handleRequest(state, 'omcCertificatePreview'),
  ),
  on(omcCertificatePreviewActions.success, (state, { response }) =>
    handleSuccess(state, 'omcCertificatePreview', response),
  ),
  on(omcCertificatePreviewActions.failure, (state, { error }) =>
    handleFailure(state, 'omcCertificatePreview', error),
  ),
  on(omcCertificatePreviewActions.clearState, (state) =>
    handleClear(state, 'omcCertificatePreview'),
  ),

  // Logged In OMC Last Months Projects
  on(loggedInOmcLastMonthsProjectsActions.request, (state) =>
    handleRequest(state, 'loggedInOmcLastMonthsProjects'),
  ),
  on(loggedInOmcLastMonthsProjectsActions.success, (state, { response }) =>
    handleSuccess(state, 'loggedInOmcLastMonthsProjects', response),
  ),
  on(loggedInOmcLastMonthsProjectsActions.failure, (state, { error }) =>
    handleFailure(state, 'loggedInOmcLastMonthsProjects', error),
  ),
  on(loggedInOmcLastMonthsProjectsActions.clearState, (state) =>
    handleClear(state, 'loggedInOmcLastMonthsProjects'),
  ),

  // BPS Calendar
  on(loadBpsCalendarActions.request, (state) => handleRequest(state, 'bpsCalendar')),
  on(loadBpsCalendarActions.success, (state, { response }) =>
    handleSuccess(state, 'bpsCalendar', response),
  ),
  on(loadBpsCalendarActions.failure, (state, { error }) =>
    handleFailure(state, 'bpsCalendar', error),
  ),
  on(loadBpsCalendarActions.clearState, (state) => handleClear(state, 'bpsCalendar')),

  // Delete OMC Demand Cargo Product
  on(deleteOmcDemandCargoProductActions.request, (state) =>
    handleRequest(state, 'deleteOmcDemandCargoProduct'),
  ),
  on(deleteOmcDemandCargoProductActions.success, (state, { response }) =>
    handleSuccess(state, 'deleteOmcDemandCargoProduct', response),
  ),
  on(deleteOmcDemandCargoProductActions.failure, (state, { error }) =>
    handleFailure(state, 'deleteOmcDemandCargoProduct', error),
  ),
  on(deleteOmcDemandCargoProductActions.clearState, (state) =>
    handleClear(state, 'deleteOmcDemandCargoProduct'),
  ),

  // Delete OMC Demand Product Usage
  on(deleteOmcDemandProductUsageActions.request, (state) =>
    handleRequest(state, 'deleteOmcDemandProductUsage'),
  ),
  on(deleteOmcDemandProductUsageActions.success, (state, { response }) =>
    handleSuccess(state, 'deleteOmcDemandProductUsage', response),
  ),
  on(deleteOmcDemandProductUsageActions.failure, (state, { error }) =>
    handleFailure(state, 'deleteOmcDemandProductUsage', error),
  ),
  on(deleteOmcDemandProductUsageActions.clearState, (state) =>
    handleClear(state, 'deleteOmcDemandProductUsage'),
  ),
);

